<template>
  <div id="app">
    <header>
      <div id="nav" class="navbar">
        <div class="logo">
          <img
            src="./assets/imagens/logo-unimed.svg"
            alt="Unimed Grande Florianópolis"
            width="97"
          />
          <span class="logo-title"> Portal de laudos </span>
        </div>
        <div v-if="isUsuarioLogado">
          <button class="button-longout" @click="deslogar">
            Sair
            <b-icon  icon="box-arrow-in-right" style="font-size: 22px;"> </b-icon>             
            </button>         
        </div>
    </div>     
    </header>
    <router-view />    
  </div>
</template>
<script>
import store from './store';

export default {
  name: 'App',
  store,
  beforeCreate() {
    document.querySelector("body").setAttribute("style", "background:#F5F5F6");
  },
  methods: {
    deslogar(){   
      this.$store.commit('USUARIO_DESLOGADO');
      this.$router.push({name: 'Login'});
    }
  },
  computed: {
    isUsuarioLogado (){
      return Boolean (this.$store.state.protocolo)
    } 
  }
};
</script>

<style>
#app {  
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

header {
  height: 70px;
  background: #f8f9fa;
  box-shadow: 0px 3px 10px #0000000d;
  opacity: 1;
}

.logo-title {
  font-size: 20px;
  margin-left: 15px;
}

.button-longout{
  color: #00945E; 
  font-weight: 500;
  border: none;
  background-color: transparent;
  margin-right: 25px;
}

 @media (min-width: 320px) {
  .logo {
    margin-left: 20px;
  }
}

@media (min-width: 480px) {
  .logo {
    margin-left: 20px;
  }
}

@media (min-width: 576px) {
  .logo {
    margin-left: 20px;
  }
}

@media (min-width: 768px) {
  .logo {
    margin-left: 40px;
  }
}

@media (min-width: 992px) {
  .logo {
    margin-left: 80px;
  }
}

@media (min-width: 1200px) {
  .logo {
    margin-left: 140px;
  }
} 
</style>